export const saveData = (function () {
  const a = document.createElement("a")
  document.body.appendChild(a)
  a.style.display = "none"
  return function (data ) {
    const fileData = data,
      blob = new Blob([fileData], {type: "octet/stream"}),
      url = window.URL.createObjectURL(blob)
    if('msSaveOrOpenBlob' in navigator){
      window.navigator.msSaveOrOpenBlob(blob, "NationalGrid_Inventory_Report.csv" )
      return
    }
    a.href = url
    a.download = "NationalGrid_Inventory_Report.csv"
    a.click()
    window.URL.revokeObjectURL(url)
  }
}())